export const ConsumerEmailFormStyles = {
  container: 'flex flex-col w-full items-center',
  emailField: 'w-full mt-3 mb-8 sm:w-auto sm:mb-2',
  submitButton: 'text-xl sm:text-2xl mt-auto mb-3',
}
